export const FETCH_END = 'FETCH_END';
export const FETCH_END_IMAGES = 'FETCH_END_IMAGES';
export const FETCH_IMAGE_PROVIDERS_END = 'FETCH_IMAGE_PROVIDERS_END';
export const SET_FETCH_IMAGES_ERROR = 'SET_FETCH_IMAGES_ERROR';
export const FETCH_IMAGE_PROVIDERS_START = 'FETCH_IMAGE_PROVIDERS_STAR';
export const FETCH_IMAGES_ERROR = 'FETCH_IMAGES_ERROR';
export const IMAGE_NOT_FOUND = 'IMAGE_NOT_FOUND';
export const FETCH_START = 'FETCH_START';
export const FETCH_START_IMAGES = 'FETCH_START_IMAGES';
export const SET_FILTER = 'SET_FILTER';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_FILTER_IS_VISIBLE = 'SET_FILTER_IS_VISIBLE';
export const SET_GRID_FILTER = 'SET_GRID_FILTER';
export const SET_IMAGE = 'SET_IMAGE';
export const SET_IMAGE_PAGE = 'SET_IMAGE_PAGE';
export const SET_IMAGE_PROVIDERS = 'SET_IMAGE_PROVIDERS';
export const SET_PROVIDERS_FILTERS = 'SET_PROVIDERS_FILTERS';
export const SET_IMAGES = 'SET_IMAGES';
export const SET_IS_PAGE_CHANGE = 'SET_IS_PAGE_CHANGE';
export const SET_QUERY = 'SET_QUERY';
export const SET_COLLECTION_QUERY = 'SET_COLLECTION_QUERY';
export const SET_RELATED_IMAGES = 'SET_RELATED_IMAGES';
export const SET_SHARE_URL = 'SET_SHARE_URL';
export const UNSET_SHARE_URL = 'UNSET_SHARE_URL';
export const REPORT_BUG_START = 'REPORT_BUG_START';
export const REPORT_BUG_END = 'REPORT_BUG_END';
export const REPORT_BUG_FAILED = 'REPORT_BUG_FAILED';
export const JOINED_AB_TEST_EXPERIMENT = 'JOINED_AB_TEST_EXPERIMENT';
export const HANDLE_NO_IMAGES = 'HANDLE_NO_IMAGES';
export const TOGGLE_REPORT_FORM_VISIBILITY = 'TOGGLE_REPORT_FORM_VISIBILITY';
export const REPORT_SENT = 'REPORT_SENT';
export const REPORT_ERROR = 'REPORT_ERROR';
export const BACK_TO_REPORT_START = 'BACK_TO_REPORT_START';
export const REPORT_FORM_CLOSED = 'REPORT_FORM_CLOSED';
